<!-- =========================================================================================
  File Name: VerticalSidebar.vue
  Description: Sidebar Component
  Component Name: VerticalSidebar
========================================================================================== -->

<template>
  <section class="lg:relative absolute grid justify-center items-start place-content-center">
    <div
      class="py-6 flex flex-col justify-start fixed bg-white shadow-sm rounded-lg gap-8 w-24 place-content-center justify-self-center"
      style="height: 93%">
      <router-link class="flex relative items-center w-full justify-center cursor-pointer" to="/user/dashboard">
        <img class="w-auto h-12 object-cover" src="@/assets/images/new-sidebar/icon.svg" />
      </router-link>

      <span class="w-auto bg-slate-100 mx-4 rounded-full my-0 xl:my-0" style="padding: 0.5px 0px"></span>

      <div class="flex relative items-center w-full justify-center flex-col xl:gap-6 gap-4">
        <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.dashboard')" position="right" class="flex flex-col w-full">
          <router-link to="/user/dashboard"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item"
            :class="activeRoute === 'user-home' ? 'sidebar__item__active' : ''">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                <path
                  d="M21.743 12.331L12.743 2.331C12.364 1.909 11.636 1.909 11.257 2.331L2.25698 12.331C2.12767 12.4747 2.04277 12.6527 2.01255 12.8436C1.98232 13.0345 2.00807 13.2301 2.08668 13.4067C2.16529 13.5833 2.29339 13.7333 2.45548 13.8386C2.61757 13.9439 2.8067 13.9999 2.99998 14H4.99998V21C4.99998 21.2652 5.10534 21.5196 5.29288 21.7071C5.48041 21.8946 5.73477 22 5.99998 22H18C18.2652 22 18.5196 21.8946 18.7071 21.7071C18.8946 21.5196 19 21.2652 19 21V14H21C21.1936 14.0008 21.3834 13.9453 21.546 13.8401C21.7087 13.735 21.8372 13.5848 21.916 13.4079C21.9947 13.231 22.0203 13.0349 21.9896 12.8437C21.9589 12.6525 21.8732 12.4744 21.743 12.331ZM12 16C11.2043 16 10.4413 15.6839 9.87866 15.1213C9.31605 14.5587 8.99998 13.7956 8.99998 13C8.99998 12.2043 9.31605 11.4413 9.87866 10.8787C10.4413 10.3161 11.2043 10 12 10C12.7956 10 13.5587 10.3161 14.1213 10.8787C14.6839 11.4413 15 12.2043 15 13C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16Z"
                  fill="#FBB603" />
                <rect x="5" y="10" width="14" height="7" fill="#FBB603" />
                <circle cx="12" cy="17" r="3" fill="#737171" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M21.743 12.3311L12.743 2.33115C12.364 1.90915 11.636 1.90915 11.257 2.33115L2.25698 12.3311C2.12767 12.4748 2.04277 12.6529 2.01255 12.8438C1.98232 13.0347 2.00807 13.2303 2.08668 13.4068C2.16529 13.5834 2.29339 13.7334 2.45548 13.8387C2.61757 13.944 2.8067 14.0001 2.99998 14.0001H4.99998V21.0001C4.99998 21.2654 5.10534 21.5197 5.29288 21.7073C5.48041 21.8948 5.73477 22.0001 5.99998 22.0001H18C18.2652 22.0001 18.5196 21.8948 18.7071 21.7073C18.8946 21.5197 19 21.2654 19 21.0001V14.0001H21C21.1936 14.001 21.3834 13.9454 21.546 13.8403C21.7087 13.7352 21.8372 13.585 21.916 13.408C21.9947 13.2311 22.0203 13.0351 21.9896 12.8439C21.9589 12.6527 21.8732 12.4745 21.743 12.3311ZM12 16.0001C11.2043 16.0001 10.4413 15.6841 9.87866 15.1215C9.31605 14.5589 8.99998 13.7958 8.99998 13.0001C8.99998 12.2045 9.31605 11.4414 9.87866 10.8788C10.4413 10.3162 11.2043 10.0001 12 10.0001C12.7956 10.0001 13.5587 10.3162 14.1213 10.8788C14.6839 11.4414 15 12.2045 15 13.0001C15 13.7958 14.6839 14.5589 14.1213 15.1215C13.5587 15.6841 12.7956 16.0001 12 16.0001Z"
                  fill="#737171" />
                <rect x="5" y="10" width="14" height="7" fill="#737171" />
                <circle cx="12" cy="17" r="3" fill="#FBB603" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.notifications')" position="right" class="flex flex-col w-full">
          <router-link to="/user/notifications" :class="activeRoute === 'user-notifications'
              ? 'sidebar__item__active'
              : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path
                  d="M12 22C12.6193 22.0008 13.2235 21.8086 13.7285 21.4502C14.2335 21.0917 14.6143 20.5849 14.818 20H9.182C9.38566 20.5849 9.76648 21.0917 10.2715 21.4502C10.7765 21.8086 11.3807 22.0008 12 22ZM19 14.586V10C19 6.783 16.815 4.073 13.855 3.258C13.562 2.52 12.846 2 12 2C11.154 2 10.438 2.52 10.145 3.258C7.185 4.074 5 6.783 5 10V14.586L3.293 16.293C3.19996 16.3857 3.12617 16.4959 3.07589 16.6172C3.0256 16.7386 2.99981 16.8687 3 17V18C3 18.2652 3.10536 18.5196 3.29289 18.7071C3.48043 18.8946 3.73478 19 4 19H20C20.2652 19 20.5196 18.8946 20.7071 18.7071C20.8946 18.5196 21 18.2652 21 18V17C21.0002 16.8687 20.9744 16.7386 20.9241 16.6172C20.8738 16.4959 20.8 16.3857 20.707 16.293L19 14.586Z"
                  fill="#F2C244" />
                <path
                  d="M12 22C12.6193 22.0008 13.2235 21.8086 13.7285 21.4502C14.2335 21.0917 14.6143 20.5849 14.818 20H9.182C9.38566 20.5849 9.76648 21.0917 10.2715 21.4502C10.7765 21.8086 11.3807 22.0008 12 22Z"
                  fill="#737171" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 22C12.6193 22.0008 13.2235 21.8086 13.7285 21.4502C14.2335 21.0917 14.6143 20.5849 14.818 20H9.182C9.38566 20.5849 9.76648 21.0917 10.2715 21.4502C10.7765 21.8086 11.3807 22.0008 12 22ZM19 14.586V10C19 6.783 16.815 4.073 13.855 3.258C13.562 2.52 12.846 2 12 2C11.154 2 10.438 2.52 10.145 3.258C7.185 4.074 5 6.783 5 10V14.586L3.293 16.293C3.19996 16.3857 3.12617 16.4959 3.07589 16.6172C3.0256 16.7386 2.99981 16.8687 3 17V18C3 18.2652 3.10536 18.5196 3.29289 18.7071C3.48043 18.8946 3.73478 19 4 19H20C20.2652 19 20.5196 18.8946 20.7071 18.7071C20.8946 18.5196 21 18.2652 21 18V17C21.0002 16.8687 20.9744 16.7386 20.9241 16.6172C20.8738 16.4959 20.8 16.3857 20.707 16.293L19 14.586Z"
                  fill="#737171" />
                <path
                  d="M11.9977 22C12.617 22.0008 13.2211 21.8086 13.7262 21.4502C14.2312 21.0917 14.612 20.5849 14.8157 20H9.17969C9.38335 20.5849 9.76416 21.0917 10.2692 21.4502C10.7742 21.8086 11.3784 22.0008 11.9977 22Z"
                  fill="#FBB603" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.boards')" position="right" class="flex flex-col w-full">
          <router-link to="/user/boards" :class="activeRoute === 'user-boards' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                <rect x="3" y="3" width="8" height="8" rx="2" fill="#F2C244" />
                <rect x="3" y="13" width="8" height="8" rx="2" fill="#F2C244" />
                <rect x="13" y="3" width="8" height="8" rx="2" fill="#737171" />
                <rect x="13" y="13" width="8" height="8" rx="2" fill="#F2C244" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="8" height="8" rx="2" fill="#737171" />
                <rect x="3" y="13" width="8" height="8" rx="2" fill="#737171" />
                <rect x="13" y="3" width="8" height="8" rx="2" fill="#FBB603" />
                <rect x="13" y="13" width="8" height="8" rx="2" fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.reviews')" position="right" class="hidden flex-col w-full">
          <router-link to="/reviews" :class="activeRoute === 'user-reviews' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path
                  d="M8 12.0518C9.995 12.0518 11.5 10.5468 11.5 8.55176C11.5 6.55676 9.995 5.05176 8 5.05176C6.005 5.05176 4.5 6.55676 4.5 8.55176C4.5 10.5468 6.005 12.0518 8 12.0518ZM9 12.9998H7C4.243 12.9998 2 15.2428 2 17.9998V18.9998H14V17.9998C14 15.2428 11.757 12.9998 9 12.9998ZM20.294 8.29176L15.994 12.5838L14.702 11.2918L13.288 12.7058L15.994 15.4098L21.706 9.70776L20.294 8.29176Z"
                  fill="#F2C046" />
                <path
                  d="M20.294 8.29199L15.994 12.584L14.702 11.292L13.288 12.706L15.994 15.41L21.706 9.70799L20.294 8.29199Z"
                  fill="#737171" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M8 12.0518C9.995 12.0518 11.5 10.5468 11.5 8.55176C11.5 6.55676 9.995 5.05176 8 5.05176C6.005 5.05176 4.5 6.55676 4.5 8.55176C4.5 10.5468 6.005 12.0518 8 12.0518ZM9 12.9998H7C4.243 12.9998 2 15.2428 2 17.9998V18.9998H14V17.9998C14 15.2428 11.757 12.9998 9 12.9998ZM20.294 8.29176L15.994 12.5838L14.702 11.2918L13.288 12.7058L15.994 15.4098L21.706 9.70776L20.294 8.29176Z"
                  fill="#737171" />
                <path
                  d="M20.294 8.29199L15.994 12.584L14.702 11.292L13.288 12.706L15.994 15.41L21.706 9.70799L20.294 8.29199Z"
                  fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.community')" position="right" class="flex-col w-full">
          <router-link to="/user/community" :class="activeRoute === 'user-community' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path
                  d="M21 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V7H2V9H4V11H2V13H4V15H2V17H4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM13 4.999C14.648 4.999 16 6.35 16 7.999C15.9971 8.79385 15.6801 9.55533 15.1182 10.1175C14.5562 10.6796 13.7948 10.9968 13 11C11.353 11 10 9.647 10 7.999C10 6.35 11.353 4.999 13 4.999ZM19 18H7V17.25C7 15.031 9.705 12.75 13 12.75C16.295 12.75 19 15.031 19 17.25V18Z"
                  fill="#F2C046" />
                <path d="M2 7H4V9V11V13V15V17H2V15H4V13H2V11H4V9H2V7Z" fill="#F2C046" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M21 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V7H2V9H4V11H2V13H4V15H2V17H4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM13 4.999C14.648 4.999 16 6.35 16 7.999C15.9971 8.79385 15.6801 9.55533 15.1182 10.1175C14.5562 10.6796 13.7948 10.9968 13 11C11.353 11 10 9.647 10 7.999C10 6.35 11.353 4.999 13 4.999ZM19 18H7V17.25C7 15.031 9.705 12.75 13 12.75C16.295 12.75 19 15.031 19 17.25V18Z"
                  fill="#737171" />
                <path d="M2 7H4V9V11V13V15V17H2V15H4V13H2V11H4V9H2V7Z" fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.wallet')" position="right" class="flex flex-col w-full">
          <router-link to="/user/wallet" :class="activeRoute === 'user-wallet' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path d="M14 9H22V15H14V9Z" fill="#737171" />
                <path
                  d="M20 3H5C3.346 3 2 4.346 2 6V18C2 19.654 3.346 21 5 21H20C21.103 21 22 20.103 22 19V17H14C12.897 17 12 16.103 12 15V9C12 7.897 12.897 7 14 7H22V5C22 3.897 21.103 3 20 3Z"
                  fill="#F2C046" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M14 9H22V15H14V9Z" fill="#FBB603" />
                <path
                  d="M20 3H5C3.346 3 2 4.346 2 6V18C2 19.654 3.346 21 5 21H20C21.103 21 22 20.103 22 19V17H14C12.897 17 12 16.103 12 15V9C12 7.897 12.897 7 14 7H22V5C22 3.897 21.103 3 20 3Z"
                  fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip text="Apps Store" position="right" class="hidden flex-col w-full">
          <router-link to="/apps" :class="activeRoute === 'user-apps' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path
                  d="M18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.65685 16.3431 9 18 9Z"
                  fill="#737171" />
                <path
                  d="M13 6C13 5.288 13.153 4.613 13.422 4H6C4.897 4 4 4.897 4 6V18C4 19.103 4.897 20 6 20H18C19.103 20 20 19.103 20 18V10.578C19.3698 10.8559 18.6887 10.9997 18 11C16.6739 11 15.4021 10.4732 14.4645 9.53553C13.5268 8.59785 13 7.32608 13 6Z"
                  fill="#F2C046" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.65685 16.3431 9 18 9Z"
                  fill="#737171" />
                <path
                  d="M13 6C13 5.288 13.153 4.613 13.422 4H6C4.897 4 4 4.897 4 6V18C4 19.103 4.897 20 6 20H18C19.103 20 20 19.103 20 18V10.578C19.3698 10.8559 18.6887 10.9997 18 11C16.6739 11 15.4021 10.4732 14.4645 9.53553C13.5268 8.59785 13 7.32608 13 6Z"
                  fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>
      </div>

      <span class="w-auto bg-slate-100 mx-4 rounded-full xl:my-0 my-0" style="padding: 0.5px 0px"></span>

      <div class="flex relative items-center w-full justify-end flex-col gap-8 h-full">
        <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.myOrganizations')" position="right" class="flex flex-col w-full">
          <router-link to="/organization/my-organizations" :class="activeRoute === 'user-organizations'
              ? 'sidebar__item__active'
              : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                <g clip-path="url(#clip0_727_174)">
                  <path
                    d="M12 0C5.38248 0 0 5.38248 0 12C0 18.6175 5.38248 24 12 24C18.6175 24 24 18.6175 24 12C24 5.38248 18.6175 0 12 0ZM12.6014 1.69872C15.6778 1.87464 18.3866 3.39144 20.1581 5.67504C19.6906 5.66304 19.2252 5.66016 18.7618 5.66712C17.9573 5.68046 17.1535 5.72305 16.3522 5.7948C16.2048 5.49062 15.9748 5.23408 15.6884 5.05454C15.402 4.875 15.0709 4.77972 14.7329 4.7796C14.6491 4.77961 14.5655 4.78546 14.4826 4.79712C13.9189 3.72714 13.2907 2.69243 12.6014 1.69872ZM11.1427 1.71792C12.0156 2.91048 12.7723 4.12104 13.4198 5.3484C13.179 5.60532 13.0188 5.92725 12.959 6.27432C11.8394 6.49247 10.7316 6.76723 9.63984 7.09752C9.50399 6.91384 9.33441 6.7577 9.14016 6.63744C9.59304 5.02104 10.2266 3.38328 11.0366 1.72584C11.0719 1.72272 11.1074 1.72104 11.1427 1.71792ZM9.59712 1.9632C8.92032 3.4428 8.38032 4.91688 7.97856 6.3816C7.73553 6.41076 7.50099 6.48918 7.2893 6.61207C7.07761 6.73496 6.8932 6.89973 6.74736 7.09632C5.66449 6.75096 4.5677 6.45086 3.45984 6.1968C4.90576 4.06933 7.09482 2.55928 9.59712 1.9632ZM19.4666 6.86352C19.9687 6.86664 20.4732 6.88272 20.9803 6.90912C21.5865 7.97675 21.9959 9.14457 22.1892 10.357C20.7372 10.5931 19.3236 10.9202 17.9474 11.3326C17.7989 11.1486 17.6155 10.9957 17.4079 10.8826C17.2002 10.7695 16.9723 10.6985 16.7371 10.6735C16.5058 9.75256 16.2241 8.84503 15.893 7.95504C16.1907 7.70391 16.3989 7.36301 16.4863 6.98352C17.4701 6.89808 18.463 6.85704 19.4666 6.86352ZM2.81568 7.2864C4.04016 7.55592 5.23488 7.87104 6.3948 8.24136C6.39487 8.24376 6.39496 8.24616 6.39504 8.24856C4.83312 8.89008 3.29736 9.64656 1.78728 10.5134C1.94881 9.38819 2.29635 8.29763 2.81568 7.2864ZM13.1582 7.45056C13.3138 7.73185 13.5419 7.96635 13.8188 8.12969C14.0956 8.29302 14.4112 8.37923 14.7326 8.37936C14.7488 8.37918 14.765 8.37878 14.7811 8.37816C15.0949 9.21835 15.3622 10.0752 15.5818 10.9447C15.4916 11.0019 15.4067 11.0669 15.3281 11.1391C13.6356 10.0361 11.8489 9.08491 9.9888 8.2968C9.99027 8.27634 9.99139 8.25586 9.99216 8.23536C11.0338 7.92079 12.0903 7.65886 13.1582 7.45056ZM6.84168 9.3564C6.97403 9.50691 7.13058 9.63426 7.30488 9.7332C7.0092 12.047 7.07472 14.3285 7.52592 16.5602C6.46259 17.3378 5.43815 18.1672 4.45632 19.0454C2.73408 17.2025 1.68 14.7278 1.68 12C1.68 11.9887 1.68096 11.9779 1.68096 11.9666C3.37224 10.9505 5.0916 10.0776 6.84168 9.3564ZM9.51048 9.3948C11.344 10.1696 13.1033 11.1092 14.767 12.2021C14.754 12.2887 14.7475 12.3761 14.7473 12.4637C14.7473 12.4674 14.7473 12.4712 14.7473 12.475C12.5969 13.369 10.5439 14.4862 8.586 15.8143C8.2476 13.8948 8.2116 11.9383 8.46432 9.94776C8.86539 9.88661 9.23404 9.69175 9.51048 9.3948ZM22.3087 11.5534C22.315 11.7014 22.32 11.8502 22.32 12C22.3215 13.4617 22.012 14.907 21.4121 16.2398C20.402 15.1642 19.3221 14.1563 18.1795 13.2226C18.2896 12.986 18.3469 12.7282 18.3475 12.4673C19.6475 12.0799 20.9705 11.7747 22.3087 11.5534ZM15.1524 13.6003C15.4114 13.9183 15.7713 14.1383 16.1724 14.2238C16.435 16.602 16.3548 19.0397 15.9487 21.539C14.6965 22.0562 13.3548 22.3215 12 22.32C11.6455 22.32 11.2951 22.3022 10.95 22.2674C9.98712 20.5721 9.29184 18.8426 8.85504 17.0818C10.8538 15.6842 12.9502 14.5198 15.1524 13.6003ZM17.3558 14.0947C18.5892 15.0997 19.7473 16.1936 20.821 17.3676C19.9392 18.8142 18.7155 20.022 17.2574 20.8848C17.5658 18.5803 17.603 16.3142 17.3558 14.0947ZM7.82544 17.8282C8.20704 19.2425 8.7456 20.6354 9.44616 22.0025C7.92921 21.6168 6.52042 20.8896 5.32728 19.8766C6.14256 19.1518 6.97512 18.4678 7.82544 17.8282Z"
                    fill="#FBB603" />
                </g>
                <defs>
                  <clipPath id="clip0_727_174">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_727_159)">
                  <path
                    d="M12 0C5.38248 0 0 5.38248 0 12C0 18.6175 5.38248 24 12 24C18.6175 24 24 18.6175 24 12C24 5.38248 18.6175 0 12 0ZM12.6014 1.69872C15.6778 1.87464 18.3866 3.39144 20.1581 5.67504C19.6906 5.66304 19.2252 5.66016 18.7618 5.66712C17.9573 5.68046 17.1535 5.72305 16.3522 5.7948C16.2048 5.49062 15.9748 5.23408 15.6884 5.05454C15.402 4.875 15.0709 4.77972 14.7329 4.7796C14.6491 4.77961 14.5655 4.78546 14.4826 4.79712C13.9189 3.72714 13.2907 2.69243 12.6014 1.69872ZM11.1427 1.71792C12.0156 2.91048 12.7723 4.12104 13.4198 5.3484C13.179 5.60532 13.0188 5.92725 12.959 6.27432C11.8394 6.49247 10.7316 6.76723 9.63984 7.09752C9.50399 6.91384 9.33441 6.7577 9.14016 6.63744C9.59304 5.02104 10.2266 3.38328 11.0366 1.72584C11.0719 1.72272 11.1074 1.72104 11.1427 1.71792ZM9.59712 1.9632C8.92032 3.4428 8.38032 4.91688 7.97856 6.3816C7.73553 6.41076 7.50099 6.48918 7.2893 6.61207C7.07761 6.73496 6.8932 6.89973 6.74736 7.09632C5.66449 6.75096 4.5677 6.45086 3.45984 6.1968C4.90576 4.06933 7.09482 2.55928 9.59712 1.9632ZM19.4666 6.86352C19.9687 6.86664 20.4732 6.88272 20.9803 6.90912C21.5865 7.97675 21.9959 9.14457 22.1892 10.357C20.7372 10.5931 19.3236 10.9202 17.9474 11.3326C17.7989 11.1486 17.6155 10.9957 17.4079 10.8826C17.2002 10.7695 16.9723 10.6985 16.7371 10.6735C16.5058 9.75256 16.2241 8.84503 15.893 7.95504C16.1907 7.70391 16.3989 7.36301 16.4863 6.98352C17.4701 6.89808 18.463 6.85704 19.4666 6.86352ZM2.81568 7.2864C4.04016 7.55592 5.23488 7.87104 6.3948 8.24136C6.39487 8.24376 6.39496 8.24616 6.39504 8.24856C4.83312 8.89008 3.29736 9.64656 1.78728 10.5134C1.94881 9.38819 2.29635 8.29763 2.81568 7.2864ZM13.1582 7.45056C13.3138 7.73185 13.5419 7.96635 13.8188 8.12969C14.0956 8.29302 14.4112 8.37923 14.7326 8.37936C14.7488 8.37918 14.765 8.37878 14.7811 8.37816C15.0949 9.21835 15.3622 10.0752 15.5818 10.9447C15.4916 11.0019 15.4067 11.0669 15.3281 11.1391C13.6356 10.0361 11.8489 9.08491 9.9888 8.2968C9.99027 8.27634 9.99139 8.25586 9.99216 8.23536C11.0338 7.92079 12.0903 7.65886 13.1582 7.45056ZM6.84168 9.3564C6.97403 9.50691 7.13058 9.63426 7.30488 9.7332C7.0092 12.047 7.07472 14.3285 7.52592 16.5602C6.46259 17.3378 5.43815 18.1672 4.45632 19.0454C2.73408 17.2025 1.68 14.7278 1.68 12C1.68 11.9887 1.68096 11.9779 1.68096 11.9666C3.37224 10.9505 5.0916 10.0776 6.84168 9.3564ZM9.51048 9.3948C11.344 10.1696 13.1033 11.1092 14.767 12.2021C14.754 12.2887 14.7475 12.3761 14.7473 12.4637C14.7473 12.4674 14.7473 12.4712 14.7473 12.475C12.5969 13.369 10.5439 14.4862 8.586 15.8143C8.2476 13.8948 8.2116 11.9383 8.46432 9.94776C8.86539 9.88661 9.23404 9.69175 9.51048 9.3948ZM22.3087 11.5534C22.315 11.7014 22.32 11.8502 22.32 12C22.3215 13.4617 22.012 14.907 21.4121 16.2398C20.402 15.1642 19.3221 14.1563 18.1795 13.2226C18.2896 12.986 18.3469 12.7282 18.3475 12.4673C19.6475 12.0799 20.9705 11.7747 22.3087 11.5534ZM15.1524 13.6003C15.4114 13.9183 15.7713 14.1383 16.1724 14.2238C16.435 16.602 16.3548 19.0397 15.9487 21.539C14.6965 22.0562 13.3548 22.3215 12 22.32C11.6455 22.32 11.2951 22.3022 10.95 22.2674C9.98712 20.5721 9.29184 18.8426 8.85504 17.0818C10.8538 15.6842 12.9502 14.5198 15.1524 13.6003ZM17.3558 14.0947C18.5892 15.0997 19.7473 16.1936 20.821 17.3676C19.9392 18.8142 18.7155 20.022 17.2574 20.8848C17.5658 18.5803 17.603 16.3142 17.3558 14.0947ZM7.82544 17.8282C8.20704 19.2425 8.7456 20.6354 9.44616 22.0025C7.92921 21.6168 6.52042 20.8896 5.32728 19.8766C6.14256 19.1518 6.97512 18.4678 7.82544 17.8282Z"
                    fill="#737171" />
                </g>
                <defs>
                  <clipPath id="clip0_727_159">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>
      </div>

      <div class="hidden relative items-center w-full justify-center flex-col gap-8">
        <div class="grid place-content-center justify-center grid-flow-col items-center gap-4">
          <div class="flex justify-between items-center p-2 bg-green-400 rounded-lg gap-4 w-fit">
            <img class="w-4" src="@/assets/images/new-sidebar/icon.svg" />
          </div>

          <a class="text-base font-normal text-slate-500 bg-none w-fit rounded-lg toggle">Board Name</a>
        </div>

        <div class="grid place-content-center justify-center grid-flow-col items-center gap-4">
          <div class="flex justify-between items-center p-2 bg-blue-400 rounded-lg gap-4 w-fit">
            <img class="w-4" src="@/assets/images/new-sidebar/icon.svg" />
          </div>

          <a class="text-base font-normal text-slate-500 bg-none w-fit rounded-lg toggle">Board Name</a>
        </div>

        <div class="grid place-content-center justify-center grid-flow-col items-center gap-4">
          <div class="flex justify-between items-center p-2 bg-purple-400 rounded-lg gap-4 w-fit">
            <img class="w-4" src="@/assets/images/new-sidebar/icon.svg" />
          </div>

          <a class="text-base font-normal text-slate-500 bg-none w-fit rounded-lg toggle">Board Name</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "v-nav-menu",
  components: {},
  props: {},
  computed: {
    activeRoute() {
      return this.$route.name.toLowerCase();
    },
  },
  created() {
    if (this.isUserLoggedIn) {
      this.$store
        .dispatch("boards/fetchUserBoardData", this.$store.state.auth.user._id)
        .then((res) => {
          if (res.data) {
            this.organizationIds = res.data.boardData.organizationId;
          }
        })
        .catch((err) => {
          throw err;
        });
    }
    this.$store
      .dispatch("boards/fetchUserBoardData", this.$store.state.auth.user._id)
      .then((res) => { })
      .catch((err) => {
        throw err;
      });
    this.$store
      .dispatch("users/fetchUser", this.$store.state.auth.user._id)
      .then((res) => {
        this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
      });
  },
};
</script>

<style lang="scss">
.sidebar__item {
  cursor: pointer;

  .__hover {
    transition: all 0.1s ease-in;
    opacity: 0;
  }
}

.sidebar__item:hover {
  .__hover {
    opacity: 1;
  }
}

.sidebar__item__active {
  cursor: pointer;

  .__hover {
    transition: all 0.1s ease-in;
    opacity: 1;
  }
}

.toggle {
  display: none;
}

.active path {
  stroke: #ffcc00 !important;
}
</style>
